import { ca } from '@cian/analytics';

export function trackInvitePopupAccept() {
  ca('event', {
    name: 'oldevent',
    category: 'VerificationPopup',
    action: 'Click',
    label: 'Confirm',
  });
}
export function trackCheckInvitePopupCancel() {
  ca('event', {
    name: 'oldevent',
    category: 'VerificationPopup',
    action: 'Click',
    label: 'Unpublished',
  });
}
export function trackCheckInvitePopupClose() {
  ca('event', {
    name: 'oldevent',
    category: 'VerificationPopup',
    action: 'Close',
    label: '',
  });
}
export function trackSetAppPopupClose() {
  ca('event', {
    name: 'oldevent',
    category: 'VerificationPopupAPP',
    action: 'Close',
    label: '',
  });
}
export function trackSetAppClick() {
  ca('event', {
    name: 'oldevent',
    category: 'VerificationPopupAPP',
    action: 'Click',
    label: 'Install',
  });
}
export function trackCheckInvitePopupShow() {
  ca('event', {
    name: 'oldevent',
    category: 'VerificationPopup',
    action: 'Show',
    label: '',
  });
}
